import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TInputForm from "../../common/TInputForm";

class NaverAnalyticsForm extends Component {

    constructor(props) {
        super(props);

        const { onChange, data } = props;

        if(!data.setting.naCode){
            onChange(update(data, {
                validated : {
                    $set: false
                }
            }))
        }
    }


    @autobind
    handleChangeInput(value) {
        const { onChange, data } = this.props;

        const validated = value.trim().length > 5;

        onChange(update(data, {
            setting: {
                naCode: {
                    $set: value
                },
            },
            validated : {
                $set: validated 
            }
        }))
    }

    render() {
        const { plugin, data } = this.props;
        const { naCode } = data.setting;
        return (
            <div className="desc_plugin20">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        사이트 ID
                        <TInputForm className="tf_set tf_set200" placeholder="사이트 ID를 넣어주세요." onChange={this.handleChangeInput} value={naCode}/>
                    </div>
                </div>
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            네이버 애널리틱스 가입 후 발급받은 사이트 ID를 사이트 ID 항목에 넣어주세요.
                            <a href="http://analytics.naver.com/service/index.html" target="_blank" className="link_other">설정하러 가기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

NaverAnalyticsForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default NaverAnalyticsForm
